const API_URL = `${process.env.REACT_APP_API_URL}`;

export const obtenerImagenesMacros = async () => {
    try {
        const respuesta = await fetch(API_URL + "obtener_imagenes.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
            }),
        });

        if (respuesta.ok) {
            return await respuesta.json();
        } else {
            const error = await respuesta.json();
            throw new Error(error.mensaje);
        }
    } catch (error) {
        throw new Error("Error al conectar con el servidor.");
    }

}

export const obtenerImagenesMacrosLineas = async () => {
    try {
        const respuesta = await fetch(API_URL + "obtener_imagenes_makros.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
            }),
        });

        if (respuesta.ok) {
            return await respuesta.json();
        } else {
            const error = await respuesta.json();
            throw new Error(error.mensaje);
        }
    } catch (error) {
        throw new Error("Error al conectar con el servidor.");
    }

}

export const obtenerImagenesMacrosGestion = async () => {
    try {
        const respuesta = await fetch(API_URL + "listar_imagenes.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
            }),
        });

        if (respuesta.ok) {
            return await respuesta.json();
        } else {
            const error = await respuesta.json();
            throw new Error(error.mensaje);
        }
    } catch (error) {
        throw new Error("Error al conectar con el servidor.");
    }

}

export const eliminarImagenMacro = async (nombreImagen) =>{
    try {
        const respuesta = await fetch(API_URL + "eliminar_imagen.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ nombreImagen }),
        });

        if (respuesta.ok) {
            return await respuesta.json();
        } else {
            const error = await respuesta.json();
            throw new Error(error.mensaje);
        }
    } catch (error) {
        throw new Error("Error al conectar con el servidor.");
    }
}
